<template>
  <el-container v-loading="loading" element-loading-text="Przypisywanie projektu...">
    <el-main class="main">
      <img src="/img/logo.png" alt="Kreator" height="200" />
      <p>Aby przypisać swój utworzony wcześniej projekt do zamówienia podaj jego kod poniżej.</p>
      <el-form ref="form" :model="this" :disabled="loading">
        <el-form-item>
          <el-input placeholder="Kod projektu" v-model="code"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="assignAttempt">Przypisz</el-button>
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex'
  
  export default {
    name: 'Assign',
    data() {
      return {
        code: '',
        loading: false,
        error: false
      }
    },
    computed: {
      ...mapState('user', ['status']),
      ...mapGetters('creator', [
        'project',
      ]),
    },
    methods: {
      ...mapActions('user', ['login', 'logout']),
      ...mapActions('creator', ['getOneProject', 'setProject']),
      assignAttempt() {
        this.loading = true

        this.getOneProject(this.code)
          .then((response) => {

            if (! response.success) {
              return Promise.reject('Nie znaleziono projektu. Upewnij się, że kod projektu jest poprawny. Jeżeli problem wciąż występuje, prosimy skontaktuj się z nami.');
            }

            const project = JSON.parse(JSON.stringify(response.data));
            project.orderId = this.$route.params.orderId;
            return this.setProject(project)
          })
          .then(() => {
            this.loading = false
            this.$notify({
              title: 'OK!',
              message: 'Projekt został pomyślnie przypisany do zamówienia',
              type: 'success',
              position: 'bottom-right'
            });

            window.location.href = `/editor/${this.project.hash}`
          })
          .catch((error) => {
            this.loading = false
            this.$notify.error({
              title: 'Ups!',
              message: error.message || error,
              position: 'bottom-right'
            });
          })
      },
    },
  }
</script>

<style lang="less" scoped>
  body {
    font-family: 'Raleway', sans-serif;
  }
  .el-main.main {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    p {
      max-width: 500px;
      margin: 15px auto 30px;
      color: rgb(146, 146, 146);
    }
  }
</style>